import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminNewGuestPageComponent } from './admin-new-guest.page';

const routes: Routes = [
  {
    path: '',
    component: AdminNewGuestPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminNewGuestPageRoutingModule {}
